import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Pathname } from '../Pathname';

const ProtectedRoute = (props) => {
    const { children, isProtected } = props;
    const location = useLocation();
    const token = localStorage.getItem('t_id');
    const isLoggedIn = !!token;

    useEffect(() => {
        if (!isLoggedIn && isProtected && location.pathname !== Pathname.LOGIN) {
            sessionStorage.setItem(
                'post_login_redirect',
                location.pathname + location.search
            );
        }
    }, [isLoggedIn, isProtected, location]);

    if (isLoggedIn && Pathname.LOGIN === location.pathname) {
        return <Navigate to={Pathname.HOME} replace />;
    }

    if (!isLoggedIn && isProtected) {
        return <Navigate to={Pathname.LOGIN} replace />;
    }

    return <main>{children}</main>;
};

export default ProtectedRoute;
